import { render, staticRenderFns } from "./EditCarrier.vue?vue&type=template&id=0d8a9730&scoped=true"
import script from "./EditCarrier.vue?vue&type=script&lang=js"
export * from "./EditCarrier.vue?vue&type=script&lang=js"
import style0 from "./EditCarrier.vue?vue&type=style&index=0&id=0d8a9730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a9730",
  null
  
)

export default component.exports